import { render, staticRenderFns } from "./EditCompanyPremium.vue?vue&type=template&id=86bd0e8c&scoped=true&"
import script from "./EditCompanyPremium.vue?vue&type=script&lang=js&"
export * from "./EditCompanyPremium.vue?vue&type=script&lang=js&"
import style0 from "./EditCompanyPremium.vue?vue&type=style&index=0&id=86bd0e8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86bd0e8c",
  null
  
)

export default component.exports